module.exports = __webpack_public_path__ + "static/media/Tim Brenneman.dc5afaec.jpg";